import cookie from 'cookie'

const definitions = {
  'need-upgrade': {
    cn: '浏览器版本过低，请升级浏览器。',
    en: 'Browser need upgrade for this site to work.'
  },
  'require-storage': {
    cn: '本地缓存无法使用，请关闭浏览器隐私模式',
    en: 'Unable to use local storage, please close privacy mode of your browser'
  },
  'not-found': {
    cn: '页面不存在',
    en: 'Page not found'
  },
  'back-home': {
    cn: '返回首页',
    en: 'Back to home page'
  },
  'email-taken': {
    cn: '该邮箱已注册',
    en: 'Email have been taken'
  },
  'email-not-verified': {
    cn: '邮箱未激活',
    en: 'Email not verified'
  },
  'verify-send': {
    cn: '激活邮件已发送，请查收。',
    en: 'The email for active account is sent, please check.'
  },
  'reset-send': {
    cn: '重置密码邮件已发送，请查收。',
    en: 'The email for reset password is sent.'
  },
  'password-reset': {
    cn: '重置密码',
    en: 'Password reset'
  },
  'code-125': {
    cn: '邮箱地址格式错误',
    en: 'The email address was invalid.'
  },
  'code-141': {
    cn: 'LeanEngine 超时',
    en: 'LeanEngine request timeout.'
  },
  'code-201': {
    cn: '密码不能为空',
    en: 'Password is missing or empty.'
  },
  'code-202': {
    cn: '用户名已经被占用',
    en: 'Username has already been taken.'
  },
  'code-203': {
    cn: ' 电子邮箱地址已经被占用',
    en: 'Email has already been taken.'
  },
  'code-205': {
    cn: 'A user with the specified email was not found.',
    en: ' 找不到电子邮箱地址对应的用户'
  },
  'code-206': {
    cn: '没有提供 session，无法修改用户信息',
    en: 'The user cannot be altered by a client without the session.'
  },
  'code-210': {
    cn: '用户名密码不匹配',
    en: 'The username and password mismatch.'
  },
  'code-211': {
    cn: '找不到用户',
    en: 'Could not find user.'
  },
  'code-216': {
    cn: '未验证的邮箱地址',
    en: 'Email address isn\'t verified.'
  },
  'code-219': {
    cn: '登录失败次数超过限制，请稍候再试，或者通过忘记密码重设密码',
    en: 'Failed time exceed limits, please try again later, or reset your password.'
  },
  'code-403': {
    cn: '非法请求',
    en: 'Request is fobidden.'
  },
  'code-429': {
    cn: '请求过多',
    en: 'Too many requests.'
  },
  'code-502': {
    cn: '服务器维护中',
    en: 'Server is in maintenance.'
  },
  'code-511': {
    cn: 'API 暂时不可用',
    en: 'API temporarily Unavailable.'
  },
  'title-signup': {
    cn: '注册',
    en: 'Signup'
  },
  'title-login': {
    cn: '登录',
    en: 'Login'
  },
  'title-invite': {
    cn: 'MIRROR 申请码',
    en: 'Invitation Code'
  },
  'title-regist': {
    cn: '激活帐号',
    en: 'Active email account'
  },
  'title-reset': {
    cn: '重置密码',
    en: 'Password reset'
  },
  'submit': {
    cn: '提交',
    en: 'submit'
  },
  'have-account': {
    cn: '已有帐号',
    en: 'Already have an account'
  },
  'forgot-password': {
    cn: '忘记密码',
    en: 'Forgot your password'
  },
  'wait': {
    cn: '请稍等...',
    en: 'Please wait ...'
  }
}

export default function (key) {
  let lang = cookie('lang') || (/^(\w|\s)+$/.test(document.title) ? 'en' : 'cn')
  let o = definitions[key]
  return o ? o[lang] : null
}
